<template>
  <a-dropdown>
    <template #overlay>
      <a-menu @click="handleExport">
        <a-menu-item key="csv">
          <file-text-outlined />
          Export as CSV
        </a-menu-item>
        <a-menu-item key="json">
          <code-outlined />
          Export as JSON
        </a-menu-item>
      </a-menu>
    </template>
    <a-button data-testid="http-export-button">
      <template #icon>
        <download-outlined />
      </template>
      Export
      <down-outlined />
    </a-button>
  </a-dropdown>
</template>

<script setup lang="ts">
import { DownloadOutlined, DownOutlined, FileTextOutlined, CodeOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { useHttpChecker } from '../composables/useHttpChecker'
import type { CheckResult } from '../types'

interface Props {
  results: CheckResult[]
}

const props = defineProps<Props>()

const { exportCSV, exportJSON } = useHttpChecker()

const handleExport = ({ key }: { key: string }) => {
  try {
    let content: string
    let filename: string
    let mimeType: string

    if (key === 'csv') {
      content = exportCSV(props.results) || ''
      filename = `http-check-results-${Date.now()}.csv`
      mimeType = 'text/csv'
    } else {
      content = exportJSON(props.results) || ''
      filename = `http-check-results-${Date.now()}.json`
      mimeType = 'application/json'
    }

    if (!content) {
      message.warning('No results to export')
      return
    }

    const blob = new Blob([content], { type: mimeType })
    const url = URL.createObjectURL(blob)
    
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    
    message.success(`Exported ${props.results.length} results as ${key.toUpperCase()}`)
  } catch (err) {
    console.error('Export failed:', err)
    message.error('Failed to export results')
  }
}
</script>
